import { useEffect } from "books/act";
import { documentSetTitle } from "books/document";

export type PAGE_NAME = "Card Memoir Concept" | "Card Memoir Blog";

const usePageTitle = (title: PAGE_NAME) => {
  useEffect(() => {
    documentSetTitle(title);
  }, [title]);
};

export default usePageTitle;
